export default __webpack_public_path__ + "static/revolving_door_b.6f7002b29100e7d2f13e288b8e1f2383.png";